<template>
  <b-modal
    id="receive-complete-no-invoice"
    modal-class="modal-style"
    ref="modal"
    ignore-enforce-focus-selector=".vld-overlay"
  >
    <template>
      <p class="modal-style-title not-one-row">購買完成</p>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="routeTo">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    routeTo() {
      this.$router.push({ name: '歷史購買紀錄' });
      this.$emit('confirm');
    }
  }
};
</script>
